module.exports = __webpack_public_path__ + "img/banner-img3x.png";